export const GET_WIDGET_API = 'v1/public';
export const CREATE_CHAT_API = 'v1/public'
export const GET_CHATS_API = 'v1/chat/list'